import React from "react";
import { connect } from "react-redux";
import { Table } from "semantic-ui-react";
import { fetchEvents, createEvent } from "../../actions";
import PropTypes from "prop-types";
import { gameViewRenderer, hasEvents } from "../helpers/EventUtils";

class UpcommingGameList extends React.Component {
  renderLoading = () => <div>Loading</div>;

  renderGames = () => {
    return this.props.view ? (
      <Table sortable striped style={{ fontSize: 16 }}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell colSpan="3">Upcoming Games</Table.HeaderCell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell colSpan="1">Date</Table.HeaderCell>
            {/*<Table.HeaderCell colSpan="1">Game</Table.HeaderCell>*/}
            <Table.HeaderCell colSpan="1">Club</Table.HeaderCell>
            <Table.HeaderCell colSpan="1">Location</Table.HeaderCell>
            <Table.HeaderCell colSpan="1">Year</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {/* <Item.Group divided striped>  */}
          {gameViewRenderer(this.props.events.reverse(), this.props.view)}
          {/* </Item.Group> */}
        </Table.Body>
      </Table>
    ) : (
      <React.Fragment />
    );
  };

  render() {
    return hasEvents(this.props.events)
      ? this.renderLoading()
      : this.renderGames();
  }
}

const mapStateToProps = (state) => {
  return { events: state.events };
};

UpcommingGameList.propTypes = {
  bridgeEvent: PropTypes.shape({
    event_img: PropTypes.string.isRequired,
    event_name: PropTypes.string.isRequired,
    event_id: PropTypes.string.isRequired,
    event_date: PropTypes.string.isRequired,
    event_month: PropTypes.string.isRequired,
    event_day: PropTypes.string.isRequired,
    event_year: PropTypes.string.isRequired,
    event_club: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps, { fetchEvents, createEvent })(
  UpcommingGameList
);
